<template>
  <print-bill-frame
    ref="printkgibill"
    :is-preview="true"
  />
</template>

<script>
import PrintBillFrame from '@/views/ManagementFeeKGI/components/PrintBillFrame'
export default {
  components: {
    'print-bill-frame': PrintBillFrame
  },
  mounted () {
    this.$refs.printkgibill.getBillData()
  }
}
</script>
